import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

interface NotificationProps extends React.SVGProps<SVGSVGElement> {
  outline?: boolean;
}

export const Notification: React.FC<NotificationProps> = ({ outline = false, ...props }) => {
  if (outline) {
    return <NotificationOutline {...props} />;
  }

  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22L2.01 4C2.01 2.9 2.9 2 4 2ZM13 10H11V6H13V10ZM13 14H11V12H13V14Z'
      />
    </SVG>
  );
};

export const NotificationOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <Path
      d='M3.01 4.00056V4C3.01 3.44575 3.4588 3 4 3H20C20.5477 3 21 3.45228 21 4V16C21 16.5477 20.5477 17 20 17H6H5.58579L5.29289 17.2929L3.00134 19.5844L3.01 4.00056Z'
      stroke='currentColor'
      fill='none'
      strokeWidth='2'
    />
    <Path d='M13 14H11V12H13V14Z' />
    <Path d='M13 10H11V6H13V10Z' />
  </SVG>
);
